import { MenuItem, TextField, Typography } from "@mui/material";
import { strongSelectMenuProps } from "components/common/dropdownPaper";
import { IntegrationDetail } from "features/integrationsBeta/integrationsBeta";
import { useGetExecutionTargetsQuery } from "features/integrationsBeta/platformEnums";
import { usePlatformRole } from "features/integrationsBeta/usePlatformRole";
import {
  usePendingValue,
  usePendingChanges,
} from "./pending/PendingChangesContext";
import SectionCard from "./SectionCard";

const TARGET_HELP: Record<string, string> = {
  ECS: "Runs execute as an ECS Fargate task. Schedules always run on ECS.",
  LAMBDA:
    "Webhook events are processed inside the webhook worker Lambda; a " +
    "manual Run now executes in-process. Schedules always run on ECS.",
};

/** Settings section for Integration.execution_target (superuser-editable). */
export default function ExecutionTargetSection({
  integration,
}: {
  integration: IntegrationDetail;
}) {
  const { isSuperuser } = usePlatformRole();
  const { data: targets = [] } = useGetExecutionTargetsQuery();
  const { stage } = usePendingChanges();
  const [effectiveTarget] = usePendingValue(
    "integration",
    integration.id,
    "execution_target",
    integration.execution_target,
  );

  return (
    <SectionCard title="Execution Target">
      <TextField
        select
        size="small"
        label="Execution target"
        value={effectiveTarget}
        disabled={!isSuperuser}
        onChange={(e) =>
          stage({
            entityType: "integration",
            entityId: integration.id,
            section: "execution",
            entityLabel: "Integration",
            field: "execution_target",
            fieldLabel: "Execution target",
            valueKind: "text",
            oldValue: integration.execution_target,
            newValue: e.target.value,
          })
        }
        helperText={TARGET_HELP[effectiveTarget]}
        sx={{ minWidth: 280 }}
        SelectProps={{ MenuProps: strongSelectMenuProps }}
      >
        {targets.map((t) => (
          <MenuItem key={t.value} value={t.value}>
            {t.label}
          </MenuItem>
        ))}
      </TextField>
      <Typography
        variant="caption"
        color="text.secondary"
        display="block"
        sx={{ mt: 1 }}
      >
        Where pipeline runs execute. The choice applies to manual Run now and
        webhook-triggered runs; scheduled runs are always launched on ECS by
        EventBridge.
      </Typography>
    </SectionCard>
  );
}
